import React from 'react';

import { SidebarContext, SidebarContextProps } from '@/common/components/sidebar/sidebar-context';
import { useIsMobile } from '@/shared/hooks/use-is-mobile';

type SidebarProviderProps = {
  children: React.ReactNode;
};

export function SidebarProvider({ children }: SidebarProviderProps) {
  const isMobile = useIsMobile();
  const [mobileIsOpen, setMobileIsOpen] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = React.useCallback(() => {
    return isMobile ? setMobileIsOpen(prev => !prev) : setIsOpen(prev => !prev);
  }, [isMobile, setMobileIsOpen, setIsOpen]);

  const state = isOpen ? 'expanded' : 'collapsed';

  const contextValue = React.useMemo<SidebarContextProps>(
    () => ({
      isOpen,
      setIsOpen,
      state,
      mobileIsOpen,
      setMobileIsOpen,
      toggle,
      isMobile
    }), [isOpen, state, mobileIsOpen, toggle, isMobile]
  );

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
}
